export const CommissionDataComponent = {

  minimumRate: 0,
  maximumRate: 0,
  flatRate: 0,

};
